

import { ReactNode } from 'react';
import styles from './main-layout.module.scss';

type MainLayoutProps = {
    children: ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {

    return (
        <main className={styles.mainLayoutWrapper}>
            {children}
        </main>
    )
}